export default __webpack_public_path__ + "b0da91accd769f8fc3a1cccac8995c18.png";